import { AuthRepository } from "../../../../data/repository/auth/AuthRepository";
import { CustomerRepository } from "../../../../data/repository/customer/CustomerRepository";
import { AccessToken, Auth } from "../../../model/Auth";
import { Customer } from "../../../model/Customer";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAllCustomersUseCase {
  invoke: (
    skip?: number,
    limit?: number
  ) => Promise<ResponseState<Array<Customer>>>;
}

export class GetAllCustomersUseCaseImpl implements GetAllCustomersUseCase {
  private repository: CustomerRepository;

  constructor(repository: CustomerRepository) {
    this.repository = repository;
  }

  async invoke(
    skip?: number,
    limit?: number
  ): Promise<ResponseState<Array<Customer>>> {
    try {
      let response = await this.repository.getAll(skip, limit);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
